<template>
  <b-modal
    id="modal-faqs"
    class="modal-faqs"
    centered
    no-enforce-focus
    @hidden="hideModalFaq()"
  >
    <div class="modal-faqs-itens">
      <div class="modal-faqs-itens-header">
        <button class="modal-faqs-itens-close" @click="hideModalFaq()">
          <div class="modal-faqs-itens-close__icon">
            <img
              class="img-fluid"
              src="@/assets/img/close-modal.png"
              alt="icon close"
              title="icon close"
            />
          </div>
        </button>
      </div>
      <form class="modal-faqs-itens-body" @submit.prevent="handleSubmit()">
        <div class="modal-faqs__header">
          <h2>
            <template v-if="faq.id"> Editar </template>
            <template v-else> Registrar </template>
            Faq
          </h2>
        </div>
        <div class="modal-faqs__form">
          <div class="content-input-default">
            <input
              type="text"
              name="question"
              placeholder="Descreva a pergunta..."
              required
              v-model="faq.question"
            />
          </div>
          <div class="content-input-default">
            <textarea
              name="answer"
              placeholder="Descreva a resposta..."
              required
              v-model="faq.answer"
            ></textarea>
          </div>
        </div>
        <div class="modal-faqs-btn">
          <button class="btn-green">Salvar</button>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    idSpecialty: {
      type: [Number, String],
      required: true,
    },
    editFaq: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      faq: {
        id_user: "",
        id_specialties: "",
        question: "",
        answer: "",
      },
    };
  },
  computed: {
    ...mapGetters("User", ["user"]),
  },
  watch: {
    editFaq: {
      handler(newValue) {
        if (newValue && Object.keys(newValue).length > 0) {
          this.faq = { ...newValue };
        }
      },
    },
  },
  methods: {
    ...mapActions("ContentPages", ["registerContentFaqs"]),
    async handleSubmit() {
      const message = this.faq?.id
        ? "Faq editado com sucesso!"
        : "Faq cadastrado com sucesso!";

      this.faq.id_user = this.user.id;
      this.faq.id_specialties = this.idSpecialty;

      if (this.faq?.id) {
        delete this.faq.name;
      }

      await this.registerContentFaqs(this.faq);
      this.$swal.fire({ icon: "success", html: message });
      this.hideModalFaq();
    },
    clearInput() {
      this.faq = {
        id_user: "",
        id_specialties: "",
        question: "",
        answer: "",
      };
      this.$emit("edit-faq", null);
    },
    hideModalFaq() {
      this.clearInput();
      this.$bvModal.hide("modal-faqs");
    },
  },
};
</script>

<style lang="scss">
#modal-faqs {
  @media (max-width: 991px) {
    top: initial;
    bottom: 0;
    background: var(--white);
    box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.16);
  }
  .modal-header,
  .modal-footer {
    display: none;
  }
  .modal-dialog {
    max-width: 700px;
    @media (max-width: 991px) {
      max-width: 100%;
      min-height: 100%;
      height: 100%;
      margin: 0;
    }
  }
  .modal-content {
    box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.16);
    border: 0;
    border-radius: 20px;
    @media (max-width: 991px) {
      height: 100%;
      box-shadow: none;
    }
  }
  .modal-body {
    padding: 0;
  }
}
.modal-faqs {
  &-itens {
    &-close {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      padding: 10px;
      border: 0;
      background: 0;
      transition: 500ms;
      &:hover,
      &:focus {
        cursor: pointer;
        opacity: 0.8;
      }
    }
    &-body {
      padding: 25px 20px 30px 20px;
      .modal-faqs {
        &__header {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          margin-bottom: 30px;
          h2 {
            font-size: 20px;
            font-family: "Font Light Italic";
            color: var(--black);
            margin-right: 10px;
            margin-bottom: 0;
          }
        }
        &__form {
          .content-input-default textarea {
            min-height: 250px;
          }
        }
        &-btn {
          margin-top: 50px;
        }
      }
    }
  }
}
</style>
